export interface Role {
  id: string;
  name: string;
  description: string;
}

export const roles: Role[] = [
  {
    id: 'parecerista-juridico',
    name: 'Parecerista jurídico',
    description: 'Análise jurídica especializada de documentos e processos'
  },
  {
    id: 'controlador-interno',
    name: 'Controlador interno',
    description: 'Análise de conformidade e controle interno'
  },
  {
    id: 'agente-contratacoes',
    name: 'Agente de contratações',
    description: 'Análise de processos de contratação e licitações'
  },
  {
    id: 'comissao-concurso',
    name: 'Comissão de concurso',
    description: 'Análise de processos relacionados a concursos públicos'
  },
  {
    id: 'comissao-pad',
    name: 'Comissão processante de PAD',
    description: 'Análise de processos administrativos disciplinares'
  },
  {
    id: 'fiscal-contrato',
    name: 'Fiscal de contrato',
    description: 'Análise de execução e fiscalização contratual'
  },
  {
    id: 'responsavel-rh',
    name: 'Responsável pelo RH',
    description: 'Análise de processos de recursos humanos'
  },
  {
    id: 'responsavel-financeiro',
    name: 'Responsável pela administração financeira e orçamentária',
    description: 'Análise de processos financeiros e orçamentários'
  },
  {
    id: 'responsavel-patrimonio',
    name: 'Responsável pelo patrimônio',
    description: 'Análise de processos patrimoniais'
  }
];